import React from "react";
import loading from './loading.gif'
const Spinner=()=>{
    return(
        <>
        <img src={loading} alt="loading..."/>
        </>
    )
}
export default Spinner;